export interface ManipulationType {
    value: string;
    label: string;
}

export const ManipulationTypes: ManipulationType[] = [
    { value: "A1", label: "A1" },       // Legacy type - RIR-based formula progression
    { value: "WP", label: "WP" },       // Weight Progression - only increase weight
    { value: "RP_NEW", label: "DP" }    // RP New - week-specific progression with interval-based ranges (displayed as "DP")
]

/**
 * The manipulation a newly-created exercise gets.
 *
 * Always use this instead of a positional default like `ManipulationTypes.at(0)` — A1 is first in
 * the list (it is the oldest type) but it is LEGACY, so a positional default silently created A1
 * exercises for trainers who never picked it. Order this array for display; use this constant to
 * pick a default.
 */
export const DEFAULT_MANIPULATION: string = "RP_NEW";
